import React from "react";

export const BookMarkIcon = ({
  strokeWidth = 3,
  size = "24",
  cursor = "pointer",
  color = "currentColor"
}) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none">
      <path
        d="M4.39453 6.65626C4.39453 5.40038 4.39453 4.77243 4.63894 4.29275C4.85393 3.87081 5.19698 3.52776 5.61892 3.31277C6.09861 3.06836 6.72655 3.06836 7.98243 3.06836H11.2713C12.5272 3.06836 13.1552 3.06836 13.6348 3.31277C14.0568 3.52776 14.3998 3.87081 14.6148 4.29275C14.8592 4.77243 14.8592 5.40038 14.8592 6.65626V16.523L9.62688 13.5331L4.39453 16.523V6.65626Z"
        stroke="black"
        strokeWidth="1.34546"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
